export default "__VITE_ASSET__BzeQNjWZ__"